import "@/App.css";
import { ArrowUpRight, FolderOpen, KanbanSquare, Lock, FileText } from "lucide-react";

const RESULT_GROUPS = [
  {
    id: "zusammenfassung",
    label: "Zusammenfassung",
    pages: [
      {
        id: "top10-entscheidungen",
        title: "Top 10 Entscheidungen",
        subtitle: "Was wir im Workshop beschlossen haben",
        tag: "Beschlüsse",
        href: "/results/top10-entscheidungen.html",
      },
      {
        id: "top10-action-items",
        title: "Top 10 Action Items",
        subtitle: "Was als Nächstes zu tun ist",
        tag: "To Do",
        href: "/results/top10-action-items.html",
      },
    ],
  },
  {
    id: "strategie",
    label: "Strategie & Branding",
    pages: [
      {
        id: "golden-circle",
        title: "Golden Circle",
        subtitle: "Why · How · What — Tapefabrik & taped!",
        tag: "Workshop 01",
        href: "/results/golden-circle.html",
      },
      {
        id: "branding-takeaways",
        title: "Branding & Plakat",
        subtitle: "Key Takeaways aus dem Workshop",
        tag: "Workshop 02",
        href: "/results/branding-takeaways.html",
      },
      {
        id: "medienpartner",
        title: "Medienpartner & Multiplikator:innen",
        subtitle: "Presse, Influencer und Partner für die Zukunft",
        tag: "Kommunikation",
        href: "/results/medienpartner.html",
      },
    ],
  },
  {
    id: "gelaende",
    label: "Festival-Aufbau & Gelände",
    pages: [
      {
        id: "pains-gains",
        title: "Pains & Gains",
        subtitle: "Feedback zu Gelände & Festivalaufbau",
        tag: "Feedback",
        href: "/results/pains-gains.html",
      },
      {
        id: "impact-effort",
        title: "Impact / Effort Matrix",
        subtitle: "41 Maßnahmen bewertet nach Wirkung & Aufwand",
        tag: "Verbesserungen",
        href: "/results/impact-effort-matrix.html",
      },
    ],
  },
  {
    id: "taped",
    label: "taped! Convention",
    pages: [
      {
        id: "taped-pains-gains",
        title: "Pains & Gains taped!",
        subtitle: "Rückblick auf die Convention – was funktioniert, was nicht",
        tag: "Feedback",
        href: "/results/taped-pains-gains.html",
      },
      {
        id: "taped-programmideen",
        title: "Programmideen",
        subtitle: "Neue Formate & Ideen fürs kommende Programm",
        tag: "Programm",
        href: "/results/taped-programmideen.html",
      },
      {
        id: "taped-crowdfunding",
        title: "Crowdfunding pushen",
        subtitle: "Wie holen wir mehr Unterstützung für die taped!",
        tag: "Fundraising",
        href: "/results/taped-crowdfunding.html",
      },
    ],
  },
  {
    id: "themen",
    label: "Weitere Workshop-Themen",
    pages: [
      {
        id: "contest-formate",
        title: "Contest Formate",
        subtitle: "Ideen & Formate für die Convention",
        tag: "Formate",
        href: "/results/contests.html",
      },
      {
        id: "interne-kommunikation",
        title: "Interne Kommunikation",
        subtitle: "Wie wir im Team besser zusammenarbeiten",
        tag: "Team",
        href: "/results/interne-kommunikation.html",
      },
      {
        id: "wieder-bold",
        title: "\u201EWie werden wir wieder bold?!\u201C",
        subtitle: "Haltung & Programm mutiger denken",
        tag: "Haltung",
        href: "/results/boldness.html",
      },
    ],
  },
];

const JUMP_LINKS = [
  {
    id: "anydo",
    title: "Taskboards",
    subtitle: "any.do",
    icon: KanbanSquare,
    href: null,
  },
  {
    id: "gdrive",
    title: "Drive-Ordner",
    subtitle: "Google Drive",
    icon: FolderOpen,
    href: null,
  },
];

const ResultCard = ({ page, index }) => (
  <a
    href={page.href}
    data-testid={`result-link-${page.id}`}
    className="result-card fade-up"
    style={{ animationDelay: `${0.1 + index * 0.08}s` }}
  >
    <div className="result-card-top">
      <span className="result-tag">{page.tag}</span>
      <FileText className="result-icon" size={26} strokeWidth={2.2} />
    </div>
    <h3 className="result-title">{page.title}</h3>
    <p className="result-subtitle">{page.subtitle}</p>
    <div className="result-cta">
      Ergebnis öffnen <ArrowUpRight size={18} strokeWidth={2.6} />
    </div>
  </a>
);

const UpcomingCard = ({ page, index }) => (
  <div
    className="result-card result-card-upcoming fade-up"
    style={{ animationDelay: `${0.1 + index * 0.08}s` }}
    data-testid={`result-upcoming-${page.id}`}
  >
    <div className="result-card-top">
      <span className="result-tag result-tag-upcoming">In Arbeit</span>
      <Lock className="upcoming-icon" size={22} strokeWidth={2.2} />
    </div>
    <h3 className="result-title result-title-upcoming">{page.title}</h3>
    <p className="result-subtitle">{page.subtitle}</p>
  </div>
);

const JumpButton = ({ link, index }) => {
  const Icon = link.icon;
  const disabled = !link.href;
  const inner = (
    <>
      <span className="jump-icon-wrap">
        <Icon size={24} strokeWidth={2.2} />
      </span>
      <span className="jump-text">
        <span className="jump-title">{link.title}</span>
        <span className="jump-sub">{link.subtitle}</span>
      </span>
      {disabled ? (
        <span className="jump-status">
          <Lock size={14} strokeWidth={2.4} /> Link folgt
        </span>
      ) : (
        <ArrowUpRight size={20} strokeWidth={2.6} className="jump-arrow" />
      )}
    </>
  );
  if (disabled) {
    return (
      <button
        type="button"
        disabled
        data-testid={`jump-link-${link.id}-disabled`}
        className="jump-btn jump-btn-disabled fade-up"
        style={{ animationDelay: `${0.15 + index * 0.08}s` }}
        title="Link folgt in Kürze"
      >
        {inner}
      </button>
    );
  }
  return (
    <a
      href={link.href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`jump-link-${link.id}`}
      className="jump-btn fade-up"
      style={{ animationDelay: `${0.15 + index * 0.08}s` }}
    >
      {inner}
    </a>
  );
};

function App() {
  return (
    <div className="portal" data-testid="portal-page">
      <div className="texture-overlay" aria-hidden="true" />

      <header className="portal-header fade-up">
        <div className="header-inner">
          <img
            src="https://images.squarespace-cdn.com/content/v1/61ec08fcece67e13551eac0e/68e836cf-5432-42a4-a203-134d1ef2b6dd/TF_1.png"
            alt="Tapefabrik Logo"
            className="tf-logo"
            data-testid="tapefabrik-logo"
          />
          <div className="header-meta">
            <span>Internes Team-Portal</span>
            <span className="header-dot" aria-hidden="true">●</span>
            <span>Schlachthof Wiesbaden</span>
          </div>
          <h1 className="portal-title">
            Workshop-<span className="title-accent">Portal</span>
          </h1>
          <p className="portal-intro">
            Alle Ergebnisse aus unseren Workshops an einem Ort – plus die
            wichtigsten Absprungpunkte fürs Team.
          </p>
        </div>
      </header>

      <main className="portal-main">
        <section className="portal-section" data-testid="results-section">
          <div className="section-head fade-up">
            <span className="section-num">01</span>
            <h2 className="section-title">Workshop-Ergebnisse</h2>
          </div>
          <div className="result-groups">
            {RESULT_GROUPS.map((group) => (
              <div key={group.id} className="result-group" data-testid={`result-group-${group.id}`}>
                <h3 className="group-label fade-up">{group.label}</h3>
                <div className="results-grid">
                  {group.pages.map((page, i) => (
                    <ResultCard key={page.id} page={page} index={i} />
                  ))}
                  {(group.upcomingPages || []).map((page, i) => (
                    <UpcomingCard key={page.id} page={page} index={group.pages.length + i} />
                  ))}
                  {group.upcoming && (
                    <div
                      className="result-card result-card-placeholder fade-up"
                      style={{ animationDelay: "0.2s" }}
                      data-testid={`result-placeholder-${group.id}`}
                    >
                      <span className="placeholder-text">{group.upcoming}</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="portal-section" data-testid="jump-section">
          <div className="section-head fade-up">
            <span className="section-num">02</span>
            <h2 className="section-title">Absprungpunkte</h2>
          </div>
          <div className="jump-grid">
            {JUMP_LINKS.map((link, i) => (
              <JumpButton key={link.id} link={link} index={i} />
            ))}
          </div>
        </section>
      </main>

      <footer className="portal-footer fade-up">
        <span className="footer-mark">TAPEFABRIK</span>
        <span className="footer-note">
          Gegen Diskriminierung, Wackness und Sellout.
        </span>
      </footer>
    </div>
  );
}

export default App;
